import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import BlogCard from "./BlogCard";
import { useSelector } from "react-redux";
import axios from "axios";

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const loggedInUser = useSelector((state) => state.auth.user);
  const token = loggedInUser?.refreshToken;
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const fetchBlogs = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}/all/blogs/home`,
        {
          page_number: 1,
          page_size: 3,
          order_by: "ASC",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.statusType === "SUCCESS") {
        setBlogs(response.data.blogs);
      } else {
        console.error("Failed to fetch blogs");
      }
    } catch (error) {
      console.error("Error fetching blogs:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  return (
    <Row>
      {blogs.map((blog) => (
        <Col key={blog._id} md={4}>
          <BlogCard
            title={blog.title}
            description={blog.excerpt}
            imageUrl={blog.image_url}
            blogId={blog.id}
            author={blog.author}
            date={blog.publish_date}
            tags={blog.tags}
            slug={blog.slug}
          />
        </Col>
      ))}
    </Row>

  );
};

export default BlogList;
